import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Browse from "./pages/Browse";
import Genres from "./pages/Genres";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./context/AuthContext";
import { LangProvider } from "./lib/i18n";
import { PlayerProvider } from "./context/PlayerContext";
import { LiveStatsProvider } from "./context/LiveStats";
import { SmoothScroll } from "./components/SmoothScroll";
import { Header } from "./components/Header";
import { BottomPlayer } from "./components/BottomPlayer";
import { AuthDialog } from "./components/AuthDialog";
import { ShareDialog } from "./components/ShareDialog";
import Home from "./pages/Home";
import Studio from "./pages/Studio";
import Favorites from "./pages/Favorites";
import ResetPassword from "./pages/ResetPassword";
import { LiveBanner } from "./components/LiveBanner";
import { MilestoneCelebration } from "./components/MilestoneCelebration";
import MixPage from "./pages/MixPage";

function App() {
  return (
    <div className="grain min-h-screen pb-48">
      <BrowserRouter>
        <LangProvider>
        <AuthProvider>
          <LiveStatsProvider>
          <PlayerProvider>
            <SmoothScroll />
            <Header />
            <LiveBanner />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/mix/:id" element={<MixPage />} />
              <Route path="/admin" element={<Studio />} />
              <Route path="/favoritos" element={<Favorites />} />
              <Route path="/nuevos" element={<Browse kind="new" />} />
              <Route path="/populares" element={<Browse kind="popular" />} />
              <Route path="/generos" element={<Genres />} />
              <Route path="/generos/:genre" element={<Browse kind="genre" />} />
              <Route path="/restablecer" element={<ResetPassword />} />
            </Routes>
            <BottomPlayer />
            <AuthDialog />
            <ShareDialog />
            <MilestoneCelebration />
            <Toaster theme="dark" position="top-center" />
          </PlayerProvider>
          </LiveStatsProvider>
        </AuthProvider>
        </LangProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
